var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cta",class:[
    _vm.classes,
    _vm.icon ? `icon--${_vm.icon}` : '',
    _vm.containsAdviestool ? 'adviestool' : '',
  ],attrs:{"href":_vm.itemLink,"target":_vm.cta.target ? '_blank' : null,"rel":_vm.cta.target,"aria-label":_vm.cta.text}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.itemText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }